import type { SpreadLayoutTemplate } from './layout-types';

export const CUSTOM_GRID_6_LAYOUT: SpreadLayoutTemplate = {
  id: 'custom-grid-6',
  family: 'grid',
  cards: 6,
  description: 'Griglia modulare 2x3 per stese personalizzate compatte.',
  supports_focus_overlay: false,
  variants: [
    {
      id: 'portrait',
      points: [
        { x: 30, y: 24, z: 1 },
        { x: 70, y: 24, z: 1 },
        { x: 30, y: 50, z: 1 },
        { x: 70, y: 50, z: 1 },
        { x: 30, y: 76, z: 1 },
        { x: 70, y: 76, z: 1 },
      ],
    },
    {
      id: 'compact',
      points: [
        { x: 28, y: 26, z: 1 },
        { x: 72, y: 26, z: 1 },
        { x: 28, y: 52, z: 1 },
        { x: 72, y: 52, z: 1 },
        { x: 28, y: 78, z: 1 },
        { x: 72, y: 78, z: 1 },
      ],
    },
  ],
};

export const CUSTOM_GRID_9_LAYOUT: SpreadLayoutTemplate = {
  id: 'custom-grid-9',
  family: 'grid',
  cards: 9,
  description: 'Griglia 3x3 per cicli, processi evolutivi e letture a nodi multipli.',
  supports_focus_overlay: true,
  variants: [
    {
      id: 'portrait',
      points: [
        { x: 20, y: 20, z: 1 },
        { x: 50, y: 20, z: 1 },
        { x: 80, y: 20, z: 1 },
        { x: 20, y: 50, z: 1 },
        { x: 50, y: 50, z: 2 },
        { x: 80, y: 50, z: 1 },
        { x: 20, y: 80, z: 1 },
        { x: 50, y: 80, z: 1 },
        { x: 80, y: 80, z: 1 },
      ],
    },
    {
      id: 'compact',
      points: [
        { x: 22, y: 22, z: 1 },
        { x: 50, y: 22, z: 1 },
        { x: 78, y: 22, z: 1 },
        { x: 22, y: 52, z: 1 },
        { x: 50, y: 52, z: 2 },
        { x: 78, y: 52, z: 1 },
        { x: 22, y: 82, z: 1 },
        { x: 50, y: 82, z: 1 },
        { x: 78, y: 82, z: 1 },
      ],
    },
  ],
};

export const CUSTOM_CIRCLE_12_LAYOUT: SpreadLayoutTemplate = {
  id: 'custom-circle-12',
  family: 'custom',
  cards: 12,
  description: 'Cerchio a dodici carte per template utente di tipo ciclico o astrologico.',
  supports_focus_overlay: true,
  variants: [
    {
      id: 'portrait',
      points: [
        { x: 50, y: 12, z: 1 },
        { x: 68, y: 16, z: 1 },
        { x: 82, y: 28, z: 1 },
        { x: 88, y: 46, z: 1 },
        { x: 82, y: 64, z: 1 },
        { x: 68, y: 78, z: 1 },
        { x: 50, y: 84, z: 1 },
        { x: 32, y: 78, z: 1 },
        { x: 18, y: 64, z: 1 },
        { x: 12, y: 46, z: 1 },
        { x: 18, y: 28, z: 1 },
        { x: 32, y: 16, z: 1 },
      ],
    },
    {
      id: 'compact',
      points: [
        { x: 50, y: 18, z: 1 },
        { x: 66, y: 22, z: 1 },
        { x: 78, y: 32, z: 1 },
        { x: 84, y: 48, z: 1 },
        { x: 78, y: 64, z: 1 },
        { x: 66, y: 74, z: 1 },
        { x: 50, y: 78, z: 1 },
        { x: 34, y: 74, z: 1 },
        { x: 22, y: 64, z: 1 },
        { x: 16, y: 48, z: 1 },
        { x: 22, y: 32, z: 1 },
        { x: 34, y: 22, z: 1 },
      ],
    },
  ],
};
